import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { EmailTriggerState } from './email-trigger.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([EmailTriggerState])],
  declarations: []
})
export class EmailTriggerStoreModule {}
